<template>
	<div>
		<div class="routerCultureMenu">
			<router-link class="routerCultureMenuItem" to="/culture/slogan"><p class="routerCultureMenuItemTit">Company Slogan</p></router-link>
			<router-link class="routerCultureMenuItem" to="/culture/staff"><p class="routerCultureMenuItemTit">Staff Presence</p></router-link>
			<router-link class="routerCultureMenuItem" to="/culture/office"><p class="routerCultureMenuItemTit">Corporate Environment</p></router-link>
			<router-link class="routerCultureMenuItem" to="/culture/video"><p class="routerCultureMenuItemTit">Video Collection</p></router-link>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: "Culture"
}
</script>

<style scoped>
.routerCultureMenu{ font-family: 'SiYuan-Light', sans-serif; }
	@media (max-width: 465px){
		.router-link-active{ color: #07b1db !important; border-bottom: 1px solid #07b1db; }
		.routerCultureMenu{ height: 80px; border-bottom: 1px solid #e1edff; width: 98%; display: flex; flex-wrap: nowrap; animation: fadeInLeft; animation-duration: 1s; }
		.routerCultureMenuItem{ text-decoration: none; color: #d0d0d0; font-size: 12px; height: 100%; width: 33%; display: block; text-align: center; }
		.routerCultureMenuItem:hover{ color: #07c7f1; }
		.routerCultureMenuItemTit{ transition: all 0.2s linear; display: flex; align-items: center; justify-content: center; height: 80px; }
	}
	@media (min-width: 465px) and (max-width: 726px){
		.router-link-active{ color: #07b1db !important; border-bottom: 1px solid #07b1db; }
		.routerCultureMenu{ height: 36px; border-bottom: 1px solid #e1edff; width: 96%; display: flex; flex-wrap: nowrap; animation: fadeInLeft; animation-duration: 1s; }
		.routerCultureMenuItem{ text-decoration: none; color: #d0d0d0; font-size: 13px; height: 100%; width: 33%; display: block; text-align: center; }
		.routerCultureMenuItem:hover{ color: #07c7f1; }
		.routerCultureMenuItemTit{ transition: all 0.2s linear; display: flex; align-items: center; justify-content: center; height: 36px; margin: 0; }
	}
	@media (min-width: 726px){
		.router-link-active{ color: #07b1db !important; border-bottom: 1px solid #07b1db; }
		.routerCultureMenu{ height: 36px; border-bottom: 1px solid #e1edff; width: 660px; display: flex; flex-wrap: nowrap; animation: fadeInLeft; animation-duration: 1s; }
		.routerCultureMenuItem{ text-decoration: none; color: #d0d0d0; font-size: 13px; height: 100%; width: 33%; display: block; text-align: center; }
		.routerCultureMenuItem:hover{ color: #07c7f1; letter-spacing: 1px; }
		.routerCultureMenuItemTit{ transition: all 0.2s linear; display: block; height: 36px; line-height: 46px; margin: 0; }
	}
</style>